import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroConsole from '../components/sections/HeroConsole/HeroConsole';
import Container from '../components/common/Container/Container';
import GlassCard from '../components/common/GlassCard/GlassCard';
import ServiceIcon from '../components/common/ServiceIcon/ServiceIcon';
import Portfolio from '../components/sections/Portfolio/Portfolio';
import Process from '../components/sections/Process/Process';
import About from '../components/sections/About/About';

const Home = () => {
  const location = useLocation();

  // Scroll to hash on initial load
  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.substring(1);
      const timer = setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location]);

  // Scroll spy - update hash based on scroll position
  useEffect(() => {
    const sections = ['solutions', 'portfolio', 'process', 'about'];

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // Offset for header

      // Check if at the very top
      if (window.scrollY < 100) {
        if (window.location.hash) {
          window.history.replaceState(null, '', '/');
        }
        return;
      }

      // Find which section is currently in view
      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            const newHash = `#${sectionId}`;
            if (window.location.hash !== newHash) {
              window.history.replaceState(null, '', newHash);
            }
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <HeroConsole />

      {/* Placeholder — will be replaced with full Services section */}
      <section
        id="solutions"
        className="py-4xl"
        style={{
          backgroundImage: 'url("/images/stock%20images/Desktop%20Leather.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          paddingTop: '6rem',
          paddingBottom: '8rem'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            zIndex: 1
          }}
        />
        <div className="section-label">What We Do</div>
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            <GlassCard hover padding="lg" className="fade-in-up icon-group">
              <ServiceIcon type="design" />
              <h3>Website & UX/UI Design</h3>
              <p className="text-muted">
                Beautiful, intuitive designs that create exceptional user experiences.
              </p>
            </GlassCard>

            <GlassCard hover padding="lg" className="fade-in-up stagger-delay-1 icon-group">
              <ServiceIcon type="web" />
              <h3>Custom Web Applications</h3>
              <p className="text-muted">
                Tailored web solutions built to match your unique business requirements.
              </p>
            </GlassCard>

            <GlassCard hover padding="lg" className="fade-in-up stagger-delay-2 icon-group">
              <ServiceIcon type="mobile" />
              <h3>Mobile Apps</h3>
              <p className="text-muted">
                Native and cross-platform apps that deliver exceptional experiences.
              </p>
            </GlassCard>

            <GlassCard hover padding="lg" className="fade-in-up stagger-delay-3 icon-group">
              <ServiceIcon type="automation" />
              <h3>Business Automation</h3>
              <p className="text-muted">
                Streamline operations and eliminate repetitive tasks with automation.
              </p>
            </GlassCard>
          </div>
        </Container>
      </section>

      <Portfolio />

      <Process />

      <About />
    </>
  );
};

export default Home;